export const parseBooleanStringToBoolean = (param: string): boolean => {
  if (param === 'true') return true
  if (param === 'false') return false
  return false
}
